import React, { FC, useEffect } from 'react';
import { FormControl, Checkbox, FormGroup, FormControlLabel, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

type TandvardProps = {
    handleTandvardCheckbox: (value: boolean) => void;
    isTioTandvard: boolean;
};

const TandvardCheckbox: FC<TandvardProps> = ({ handleTandvardCheckbox, isTioTandvard }: TandvardProps) => {
    const { t: translate } = useTranslation(['orders']);
    const [tandvardValue, setTandvardValue] = React.useState(false);

    useEffect(() => {
        setTandvardValue(isTioTandvard || false);
    }, [isTioTandvard]);

    const handleChange = (_event: React.SyntheticEvent, checked: boolean) => {
        setTandvardValue(checked);
        handleTandvardCheckbox(checked);
    };

    return (
        <Box sx={{ marginLeft: 'auto', paddingLeft: '15px' }}>
            <FormControl component="fieldset">
                <FormGroup aria-label="position" row>
                    <FormControlLabel
                        value={tandvardValue}
                        onChange={handleChange}
                        control={<Checkbox color="secondary" checked={tandvardValue} data-test="tandvard-checkbox" />}
                        label={translate('orders:TIOTANDVARD')}
                        labelPlacement="end"
                    />
                </FormGroup>
            </FormControl>
        </Box>
    );
};

export default TandvardCheckbox;
